export default __webpack_public_path__ + "pdf/Poster.031a484.pdf";